import { Box, Text, HStack } from "@chakra-ui/react";

/** Re-usable file icon */
export const FileIcon = ({ label, bg }) => (
  <Box
    position="relative"
    w={10}
    h={12}
    bg={bg}
    borderRadius="sm"
    boxShadow="sm"
    overflow="hidden"
  >
    {/* folded corner */}
    <Box
      position="absolute"
      top={0}
      right={0}
      w={4}
      h={4}
      bg={bg}
      transform="rotate(45deg) translate(35%,-35%)"
      transformOrigin="top right"
      filter="brightness(80%)"   // a bit darker for depth
    />

    <Text
      position="absolute"
      bottom="2px"
      left="50%"
      transform="translateX(-50%)"
      fontSize="xs"
      fontWeight="bold"
      color="white"
      pointerEvents="none"
    >
      {label}
    </Text>
  </Box>
);
